import { z } from 'zod';

export const GetPreviousServiceOrderEntryOdometerQuerySchema = z.object({
  customerVehicleId: z.uuid(),
  excludeServiceOrderId: z.uuid().optional(),
  excludeReceptionId: z.uuid().optional(),
});

export type GetPreviousServiceOrderEntryOdometerQuery = z.infer<
  typeof GetPreviousServiceOrderEntryOdometerQuerySchema
>;

export const GetPreviousServiceOrderEntryOdometerResponseSchema = z.object({
  entryOdometerKm: z.number().int().nonnegative().nullable(),
});

export type GetPreviousServiceOrderEntryOdometerResponse = z.infer<
  typeof GetPreviousServiceOrderEntryOdometerResponseSchema
>;
